
import { Button } from "@/components/ui/button";
import FooterAr from "@/components/FooterAr";
import HeaderAr from "@/components/HeaderAr";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const LegalAr = () => {
  const faqs = [
    {
      question: "ما هو قانون حقوق الطبع والنشر الإماراتي وكيف ينطبق على الموسيقى؟",
      answer: "قانون حقوق الطبع والنشر الإماراتي (القانون الاتحادي رقم 7 لسنة 2002 بشأن حقوق المؤلف والحقوق المجاورة، المعدل) يحمي الأعمال الموسيقية الأصلية، ويمنح المبدعين حقوقاً حصرية للتحكم في كيفية استخدام أعمالهم. يشمل هذا الحق في إعادة الإنتاج والتوزيع والأداء والترخيص لموسيقاهم. الأداء العام للموسيقى في البيئات التجارية يتطلب ترخيصاً مناسباً."
    },
    {
      question: "من يحتاج إلى ترخيص موسيقى في دولة الإمارات؟",
      answer: "أي شركة تشغل الموسيقى في المناطق العامة تحتاج إلى ترخيص. يشمل هذا المقاهي والمطاعم ومتاجر التجزئة والمولات والفنادق والنوادي الرياضية والصالونات وغيرها من المؤسسات التي تُشغل فيها الموسيقى. حتى لو كنت تستخدم خدمات البث مثل سبوتيفاي أو أبل ميوزيك، فإن تراخيص الاستخدام الشخصي الخاصة بها لا تغطي الاستخدام التجاري."
    },
    {
      question: "ماذا يحدث إذا لم تحصل شركتي على الترخيص المناسب للموسيقى؟",
      answer: "العمل دون تراخيص موسيقية مناسبة يمكن أن يؤدي إلى عقوبات قانونية تشمل غرامات تبدأ من 10,000 درهم، وإمكانية إغلاق الشركة للمخالفات المتكررة، والإضرار بسمعة علامتك التجارية. بالإضافة إلى ذلك، قد يسعى أصحاب الحقوق الفرديون للحصول على مطالبات منفصلة للتعويض."
    },
    {
      question: "كيف يتم توزيع الأتاوات على مبدعي الموسيقى؟",
      answer: "عندما تحصل الشركات على تراخيص من خلال أمة الموسيقى، يتم جمع رسوم الاستخدام وتوزيعها على أصحاب الحقوق بناءً على الاستخدام المبلغ عنه وإطار التوزيع الخاص بنا. نستخدم تقنية التتبع المتقدمة وأنظمة التقارير لضمان التعويض العادل للمبدعين بناءً على عدد مرات تشغيل موسيقاهم."
    },
    {
      question: "كم تدوم مدة ترخيص الموسيقى وكيف أجدده؟",
      answer: "تراخيص الأعمال القياسية صالحة لمدة سنة واحدة من تاريخ الإصدار. تبدأ عملية التجديد قبل 30 يوماً من انتهاء الصلاحية من خلال لوحة أعمال أمة الموسيقى الخاصة بك، حيث يمكنك مراجعة الشروط وتحديث معلومات المؤسسة إذا لزم الأمر ومعالجة الدفع للحفاظ على الامتثال المستمر."
    }
  ];

  return (
    <div className="min-h-screen bg-musicBlack" dir="rtl">
      <HeaderAr />
      <main className="pt-24">
        {/* Hero section */}
        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0 bg-gradient-to-r from-musicBlack via-musicBlack/90 to-musicBlack/80"></div>
            <img 
              src="https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5" 
              alt="وثائق قانونية" 
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="relative z-10 editorial-container">
            <div className="max-w-2xl">
              <h1 className="editorial-heading mb-4">المركز القانوني</h1>
              <h2 className="editorial-subheading text-musicRed">نظرة عامة على حقوق الطبع والنشر الإماراتية والموارد</h2>
              <p className="editorial-body mb-8">
                تنقل في قانون حقوق الموسيقى الإماراتي مع مواردنا الشاملة، المصممة لمساعدة 
                كل من المبدعين والشركات على فهم حقوقهم والتزاماتهم القانونية.
              </p>
              <Button className="cta-button" size="lg">تحميل الدليل القانوني</Button>
            </div>
          </div>
        </section>
        
        {/* UAE Copyright Overview */}
        <section className="py-24 bg-black">
          <div className="editorial-container">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                <h2 className="editorial-heading mb-6">إطار حقوق الطبع والنشر الإماراتي</h2>
                <div className="space-y-6">
                  <p className="editorial-body">
                    أسست دولة الإمارات العربية المتحدة إطاراً قانونياً قوياً لحماية حقوق الملكية الفكرية، 
                    بما في ذلك الأعمال الموسيقية. التشريع الأساسي الذي يحكم حقوق الموسيقى هو القانون الاتحادي رقم 7 
                    لسنة 2002 بشأن حقوق المؤلف والحقوق المجاورة (المعدل بالقانون الاتحادي رقم 32 لسنة 2006).
                  </p>
                  <p className="editorial-body">
                    يتماشى هذا الإطار مع المعايير الدولية، بما في ذلك اتفاقية برن لحماية المصنفات 
                    الأدبية والفنية ومعاهدة الويبو لحقوق المؤلف، مما يوفر للمبدعين حقوقاً حصرية 
                    للتحكم في كيفية استخدام أعمالهم وضمان حصولهم على تعويض عادل.
                  </p>
                  <p className="editorial-body">
                    تعمل أمة الموسيقى كمنصة رسمية معتمدة من السلطات الإماراتية لتسهيل الامتثال 
                    لهذه القوانين، وتوفر نظاماً مبسطاً لكل من المبدعين والشركات لإدارة حقوق الموسيقى.
                  </p>
                  
                  <div className="mt-8">
                    <h3 className="font-serif text-xl font-bold mb-4">الأحكام القانونية الرئيسية:</h3>
                    <ul className="space-y-3">
                      <li className="flex items-start">
                        <span className="text-musicRed font-bold ml-2">•</span>
                        <span className="text-musicGrey">
                          <span className="text-musicWhite font-medium">مدة الحماية:</span> حقوق الطبع والنشر للأعمال الموسيقية تمتد طوال حياة المؤلف زائد 50 سنة بعد وفاته.
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-musicRed font-bold ml-2">•</span>
                        <span className="text-musicGrey">
                          <span className="text-musicWhite font-medium">حقوق الأداء العام:</span> أي أداء عام للموسيقى يتطلب ترخيصاً مناسباً من أصحاب الحقوق.
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-musicRed font-bold ml-2">•</span>
                        <span className="text-musicGrey">
                          <span className="text-musicWhite font-medium">الإنفاذ:</span> يمكن لأصحاب الحقوق التماس سبل الانتصاف القضائية بما في ذلك الأوامر القضائية والأضرار والعقوبات الجنائية للانتهاك.
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-musicRed font-bold ml-2">•</span>
                        <span className="text-musicGrey">
                          <span className="text-musicWhite font-medium">الحقوق المعنوية:</span> يحتفظ المبدعون بالحق في أن يُعرفوا كمؤلفين وفي الاعتراض على تشويه أعمالهم.
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="lg:col-span-1">
                <div className="bg-musicBlack border border-musicGrey/20 p-8 rounded-lg sticky top-28">
                  <h3 className="font-serif text-xl font-bold mb-6">الموارد القانونية</h3>
                  <ul className="space-y-4">
                    <li>
                      <a href="#" className="flex items-center text-musicWhite hover:text-musicRed transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 text-musicRed" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M12 2H2v10h10V2z" />
                          <path d="M12 2h10v10H12V2z" />
                          <path d="M12 12H2v10h10V12z" />
                          <path d="M12 12h10v10H12V12z" />
                        </svg>
                        قانون حقوق الطبع والنشر الإماراتي (النص الكامل)
                      </a>
                    </li>
                    <li>
                      <a href="#" className="flex items-center text-musicWhite hover:text-musicRed transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 text-musicRed" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                          <polyline points="14 2 14 8 20 8" />
                        </svg>
                        دليل حقوق المبدع (PDF)
                      </a>
                    </li>
                    <li>
                      <a href="#" className="flex items-center text-musicWhite hover:text-musicRed transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 text-musicRed" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                          <polyline points="14 2 14 8 20 8" />
                        </svg>
                        دليل الامتثال للشركات (PDF)
                      </a>
                    </li>
                    <li>
                      <a href="#" className="flex items-center text-musicWhite hover:text-musicRed transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 text-musicRed" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                          <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
                          <path d="M12 11h4" />
                          <path d="M12 16h4" />
                          <path d="M8 11h.01" />
                          <path d="M8 16h.01" />
                        </svg>
                        نماذج اتفاقيات الترخيص
                      </a>
                    </li>
                    <li>
                      <a href="#" className="flex items-center text-musicWhite hover:text-musicRed transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2 text-musicRed" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M16 2H2v16" />
                          <path d="M22 22H8V8" />
                        </svg>
                        إطار توزيع الأتاوات
                      </a>
                    </li>
                  </ul>
                  
                  <div className="mt-8 pt-6 border-t border-musicGrey/20">
                    <Button className="secondary-button w-full">طلب استشارة قانونية</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        {/* FAQs section */}
        <section className="py-24 bg-gradient-to-b from-black to-musicBlack">
          <div className="editorial-container">
            <h2 className="editorial-heading text-center mb-16">الأسئلة الشائعة</h2>
            
            <div className="max-w-3xl mx-auto">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, index) => (
                  <AccordionItem key={index} value={`item-${index}`} className="border-musicGrey/20">
                    <AccordionTrigger className="font-serif text-lg font-medium text-musicWhite hover:text-musicRed text-right">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-musicGrey pb-4 text-right">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </section>
        
        {/* CTA section */}
        <section className="py-16 bg-black">
          <div className="editorial-container">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="font-serif text-2xl md:text-3xl font-bold mb-4">لديك أسئلة قانونية محددة؟</h2>
              <p className="text-musicGrey mb-8 max-w-2xl mx-auto">
                فريقنا من الخبراء القانونيين المتخصصين في قانون حقوق الطبع والنشر الإماراتي يمكنه تقديم إرشادات مخصصة لحالتك.
              </p>
              <div className="flex flex-col md:flex-row justify-center gap-4">
                <Button className="cta-button" size="lg">اتصل بالفريق القانوني</Button>
                <Button variant="outline" className="secondary-button" size="lg">حدد موعد استشارة</Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterAr />
    </div>
  );
};

export default LegalAr;
